<div class="horizinns-container sales-home-container center">
    <div class="mat-row margin-auto text-center">
        <img src="/assets/images/logo_full_900.png" style="width:40%;" class="main-logo" alt="Horizinns logo" />
        <mat-card class="horizinns-card sales-home-card mw-60">
            <mat-card-content class="content">
                <h1>SALES AGENTS</h1>
                <h2>Come grow with us</h2>
                <!-- <div>
                    <button mat-raised-button type="button" (click)="openCalculator()" color="primary">
                        <mat-icon>calculate</mat-icon>
                        Commission Calculator
                    </button>
                </div> -->
            </mat-card-content>
        </mat-card>
    </div>
</div>

<section id="sales" class="sales-section">
        <div class="container">
            <div class="sales-grid">
                
                <div class="sales-content">
                    <h2>Join Our Team of Sales Agents</h2>
                    <p class="sub-head">Get Paid to Perform</p>
                    
                    <h3>Total Freedom</h3>
                    <ul>
                        <li><i class="fas fa-clock"></i> <strong>No fixed hours</strong> — set your own schedule</li>
                        <li><i class="fas fa-laptop-house"></i> <strong>Work from anywhere</strong> — home, coffee shop, or on the road</li>
                        <li><i class="fas fa-chart-line"></i> <strong>Zero quotas</strong> — no pressure, just results</li>
                        <li><i class="fas fa-dollar-sign"></i> <strong>You earn only when you win</strong> — secure a listing, get paid</li>
                    </ul>

                    <h3 style="margin-top: 30px;">No License Needed</h3>
                    <ul>
                        <li><i class="fas fa-info-circle"></i> You’re <strong>not</strong> a real estate agent or property manager</li>
                        <li><i class="fas fa-link"></i> Your job: <strong>connect</strong> Hosts and guide them to list on HORIZINNS</li>
                    </ul>

                    <div style="margin-top: 40px;">
                        <p style="margin-bottom: 10px; font-weight: bold;">QUESTIONS?</p>
                        <a (click)="goToContact()" class="btn sales-cta" style="">Contact Sales</a>
                    </div>
                </div>

                <div class="sales-visuals">
                    <table class="sales-table">
                        <thead>
                            <tr>
                                <th>Earning Stream</th>
                                <th>How It Works</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>Tiered Commissions</strong></td>
                                <td>Start strong, earn more per listing as you scale (use our calculator)</td>
                            </tr>
                            <tr>
                                <td><strong>Residual Income</strong></td>
                                <td>Same commission every year your listing renews</td>
                            </tr>
                            <tr>
                                <td><strong>Referral Bonuses</strong></td>
                                <td>10% lifetime cut from agents you bring in</td>
                            </tr>
                            <tr>
                                <td><strong>Incentive Programs</strong></td>
                                <td>Free state leads + bonus cash after 250 listings</td>
                            </tr>
                        </tbody>
                    </table>

                    
                </div>

            </div>
        </div>
    </section>
    <section class="steps-section">
        <div class="container">
            <div style="padding-top: 40px; padding-bottom: 40px;">
                <div class="steps-header">
            <p class="accent-text">READY TO EARN ON YOUR TERMS?</p>
            <h2>3 Simple Steps to Get Started</h2>
        </div>

        <div class="steps-grid">
            <div class="step-card" (click)="goToCreateAccount()">
                <div class="step-number">1</div>
                <div class="step-icon-wrapper">
                    <i class="fa-solid fa-user-plus"></i>
                </div>
                <h3>Create Account</h3>
                <p>Set up your professional Horizinns profile to access the sales network.</p>
            </div>

            <div class="step-card" (click)="goToSalesTerms()">
                <div class="step-number">2</div>
                <div class="step-icon-wrapper">
                    <i class="fa-solid fa-file-signature"></i>
                </div>
                <h3>Sign Agreement</h3>
                <p>Complete the Sales Agent Structure and Terms form to formalize your role.</p>
            </div>

            <div class="step-card">
                <div class="step-number">3</div>
                <div class="step-icon-wrapper">
                    <i class="fa-solid fa-id-card-clip"></i>
                </div>
                <h3>Share Your ID</h3>
                <p>Provide your Sales Agent ID to Hosts when they complete a listing form.</p>
            </div>
        </div>

        <div class="bonus-actions">
            <div class="bonus-item">
                <mat-icon>search</mat-icon>
                <span>Locate property hosts</span>
            </div>
            <div class="bonus-item">
                <mat-icon>group_add</mat-icon>
                <span><strong>Refer other Sales Agents:</strong> Earn 10% lifetime commission</span>
            </div>
            <div class="bonus-item">
                <mat-icon>dashboard_customize</mat-icon>
                <span>Track your earnings in the Sales Dashboard</span>
            </div>
        </div>
            </div>
        </div>
    </section>